import React, { MouseEventHandler } from 'react';
import styled from 'styled-components';
import { Color } from '~common/model/basics';
import { Box } from '~common/components/box.component';
import { theme } from '~web/view/theme';
import { getColorCode } from '~web/view/theme/colors';

interface Props {
  onClick?: MouseEventHandler<HTMLElement>;
  backgroundColor?: Color;
  backdropColorAlpha?: number;
}

export const Backdrop: React.FunctionComponent<Props> = ({
  backgroundColor = Color.Black,
  backdropColorAlpha = 0.7,
  ...rest
}) => (
  <Container backgroundColor={backgroundColor} backdropColorAlpha={backdropColorAlpha} {...rest} />
);

const Container = styled(({ backgroundColor, backdropColorAlpha, ...rest }) => <Box {...rest} />)<
  Props
>`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: ${(props): number => props.theme.zIndex.under};
  touch-action: none;
  background-color: ${(props): string =>
    theme.colors.withAlpha(getColorCode(props.backgroundColor))(props.backdropColorAlpha)};
`;



// WEBPACK FOOTER //
// /codebuild/output/src332225586/src/modules/web/src/js/view/components/layout/backdrop.component.tsx